import recentTransactions from '../data/retireeTransactions/retireeTransactions.json';

export const getAllTableData = (persona: any) => {
    const data: any = recentTransactions['data'];

    return data[persona];
};
